module.exports = __webpack_public_path__ + "static/title-d38ff1219bdca4d7729196e69ada4ce6.svg";